const ifWindowWidthLessThan = width => window.innerWidth <= width

export default ifWindowWidthLessThan
